<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit GIft Redemption
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                @change="getAvailableGift()"
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="gift"
                outlined
                v-model="form.store_gift_id"
                :items="giftItems"
                label="Gift"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.store_gift_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.user_id"
                :items="userItems"
                label="User"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="date_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update GIft Redemption
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "GiftRedemptionIdPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      giftItems: [],
      storeItems: [],
      userItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    //get data for masters
    async getMasters() {
      await axios
        .get(`gift_redemptions/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.gifts.forEach((gift) => {
            this.giftItems.push({
              id: gift.id,
              text: gift.name,
              value: gift.id,
            });
          });
          //Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
          });
          //Users
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.name,
              value: user.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    //get data (text filed)
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.giftredemptionId;
      axios
        .get(`/gift_redemptions/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(
          `/gift_redemptions/${this.$route.params.giftredemptionId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/gift_redemption/${this.form.id}`,
          from_name: "GiftEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/gift-redemptions");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
